import CodeVerification from './CodeVerification';

export default CodeVerification;
